module.exports = __webpack_public_path__ + "img/IMG_8673_L_Wood.2db13527.jpg";